import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, MapPin } from "lucide-react";
import api, { imageUrl } from "../../lib/api";

const ProjectsPanel = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/projects").then((r) => setItems(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const remove = async (p) => {
    if (!window.confirm(`Delete project "${p.title}"?`)) return;
    await api.delete(`/projects/${p._id}`);
    toast.success("Project deleted");
    load();
  };

  if (loading) return <div className="h-40 rounded-xl bg-stone-100 animate-pulse" />;

  return (
    <div data-testid="projects-panel">
      <div className="flex items-center justify-between mb-5">
        <p className="text-stone-600 text-sm">{items.length} projects</p>
        <Link to="/admin/projects/new" data-testid="add-project-btn"
          className="flex items-center gap-2 rounded-full bg-brand text-white px-5 py-2.5 text-sm font-semibold hover:bg-brand-dark transition-colors">
          <Plus size={16} /> Add Project
        </Link>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        {items.map((p) => (
          <div key={p._id} className="bg-white rounded-2xl border border-stone-200 overflow-hidden" data-testid={`project-row-${p.slug}`}>
            <div className="relative aspect-[16/9] bg-stone-100">
              {p.hero_image && <img src={imageUrl(p.hero_image)} alt="" className="w-full h-full object-cover" />}
              <span className="absolute top-3 left-3 rounded-full bg-brand text-white text-[11px] font-semibold px-3 py-1">{p.status}</span>
            </div>
            <div className="p-4 flex items-start justify-between gap-3">
              <div>
                <p className="font-semibold text-stone-800">{p.title}</p>
                <p className="flex items-center gap-1 text-xs text-stone-500 mt-0.5"><MapPin size={12} className="text-brand" /> {p.location}</p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <Link to={`/admin/projects/${p._id}/edit`} data-testid={`edit-project-${p.slug}`} className="p-2 rounded-lg hover:bg-stone-100 text-stone-600"><Pencil size={16} /></Link>
                <button onClick={() => remove(p)} data-testid={`delete-project-${p.slug}`} className="p-2 rounded-lg hover:bg-red-50 text-red-500"><Trash2 size={16} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectsPanel;
